import { render, staticRenderFns } from "./CourseAgreementTab.vue?vue&type=template&id=67580996&scoped=true"
import script from "./CourseAgreementTab.vue?vue&type=script&lang=js"
export * from "./CourseAgreementTab.vue?vue&type=script&lang=js"
import style0 from "./CourseAgreementTab.vue?vue&type=style&index=0&id=67580996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67580996",
  null
  
)

export default component.exports